// extracted by mini-css-extract-plugin
module.exports = {"numberLabel":"company-rating-module--numberLabel--36l3x","numberLabelInfo":"company-rating-module--numberLabelInfo--zBxh6"};